import instance from "config/interceptor";

export const postComplaintSubject = async (data: { subjectComplaint: string }) => {
  console.log('[POST] Create Complaint Subject:', data);
  return instance.post(`/Complaint/AddComplaintList`, data);
};

export const putComplaintSubject = async (id: number, data: { subjectComplaint: string }) => {
  console.log('[PUT] Update Complaint Subject:', data);
  return instance.post(`/Complaint/UpdateSubjectComplaint/${id}`, data);
};

export const deleteComplaintSubject = async (id: number) => {
  console.log('[DELETE] Delete Complaint Subject:', id);
  return instance.post(`/Complaint/DeleteSubjectComplaint/${id}`);
};

export const getComplainSubject = async () => {
  const { data } = await instance.get(`/Complaint/ComplaintList`);
  return data;
};

